import borders from './borders.js';
import breakpoints from './breakpoints.js';
import colors from './colors.js';
import fonts from './fonts.js';
import fontSizes from './fontSizes.js';
import fontWeights from './fontWeights.js';
import letterSpacings from './letterSpacings.js';
import lineHeights from './lineHeights.js';
import shadows from './shadows.js';
import sizes from './sizes.js';
import zIndices from './zIndices.js';
var theme = {
  colors: colors,
  breakpoints: breakpoints,
  zIndices: zIndices,
  fontSizes: fontSizes,
  lineHeights: lineHeights,
  fontWeights: fontWeights,
  letterSpacings: letterSpacings,
  fonts: fonts,
  sizes: sizes,
  shadows: shadows,
  borders: borders
};
export { theme as default };